module.exports = __webpack_public_path__ + "img/3.33cbee3c.svg";